import React, { ReactNode, useEffect, useId, useState } from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'next/image';

type InputProps = {
    name: string;
    register: any;
    errors?: any;
    label?: string | ReactNode;
    required?: boolean;
    type?: string;
    icon?: any;
    image?: string;
} & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

export const Checkbox = ({ id, name, register, errors, label, required, type, icon, image, ...props }: InputProps) => {
    const randomId = useId();
    const uuid = id ?? randomId;
    const [values, setValues] = useState();

    return (
        <div className="flex items-baseline gap-4 text-black">
            <input
                id={uuid}
                className="hidden peer"
                {...props}
                type="checkbox"
                {...register(name, { required })}
            />
            {name && (
                <label
                    htmlFor={uuid}
                    className={clsx(
                        'inline-flex items-center gap-2 w-full h-10 p-5 text-gray-900 text-sm font-medium bg-white border border-gray-300 rounded cursor-pointer peer-checked:bg-primary-50 peer-checked:border-primary-300 peer-checked:text-primary-900 hover:border-primary-300 hover:bg-primary-50',
                        { 'w-auto': type === 'goals' },
                        { 'h-auto ': type === 'products' },
                    )}
                >
                    {icon && <FontAwesomeIcon className="" icon={icon} />}
                    {/* {image && <div className='w-16 h-16 bg-gray-300' />} */}
                    {image && <Image src={image} alt="productImage" width={64} height={64} className='rounded'/>}
                    {name}
                </label>
            )}
            {errors && <p className="text-red-500 text-xs italic">{errors.message || 'Campo Richiesto'}</p>}
        </div>
    );
};
